import type { ReactNode } from 'react';
import { Button, type ButtonProps } from '../components/Button';
import { cn } from '../utils';

export interface EmptyStateAction extends ButtonProps {
  label: ReactNode;
}

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  action?: EmptyStateAction;
  secondaryAction?: EmptyStateAction;
  className?: string;
  children?: ReactNode;
}

export const EmptyState = ({
  title,
  description,
  icon,
  action,
  secondaryAction,
  className,
  children
}: EmptyStateProps) => {
  const renderAction = ({ label, ...buttonProps }: EmptyStateAction) => (
    <Button {...buttonProps}>{label}</Button>
  );

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center rounded-xl border border-dashed border-default-200 bg-content1/60 px-6 py-10 text-center',
        className
      )}>
      {icon ? <div className="mb-4 text-3xl text-default-400">{icon}</div> : null}
      <h2 className="text-xl font-semibold tracking-tight text-foreground">{title}</h2>
      {description != null &&
        (typeof description === 'string' ? (
          <p className="mt-2 max-w-lg text-md leading-6 text-default-800">{description}</p>
        ) : (
          <div className="mt-2 text-md leading-6 text-default-800">{description}</div>
        ))}

      {action || secondaryAction ? (
        <div className="mt-6 flex flex-col gap-2 sm:flex-row">
          {action ? renderAction(action) : null}
          {secondaryAction ? renderAction(secondaryAction) : null}
        </div>
      ) : null}
      {children ? <div className="mt-6">{children}</div> : null}
    </div>
  );
};
